module.exports = __webpack_public_path__ + "static/cook_county.28fd3ea1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/public_sector_logos/cook_county.png
// module id = 2217
// module chunks = 61762850755587